wbApp.controller('CompensationGroupsCtrl', ['$scope', '$modal', 'compensationGroupSvc',
function ($scope, $modal, compensationGroupSvc) {

    $scope.filterOptions = {
        filterText: ""
    };

    $scope.compensationGroups = compensationGroupSvc.getAllAsync();

    $scope.gridOptions = {
        sortInfo: { fields: ['name'], directions: ['dsc'] },
        columnDefs: [{ field: 'active', displayName: "TXT_LBL_ACTIVE", cellFilter: 'checkmark', width: '70px' },
                     { field: 'name', displayName: "TXT_LBL_NAME", sort: 'locale', width: '250px' },
                     { field: 'description', displayName: "TXT_LBL_DESCRIPTION", sort: 'locale' },
                     { field: 'isDefault', displayName: "TXT_LBL_DEFAULT", cellFilter: 'checkmark', width: '70px' },
        ]
    };

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = compensationGroupSvc.createNew();
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        compensationGroupSvc.remove(data);
    }
    
    var detailDialogPromise = $modal({
            templateUrl: 'setting/compensation-groups/compensation-groups-detail.html',
            show: false,
            scope: $scope.$new()
    });

    $scope.$on('refreshData', function (e, data) {
        $scope.compensationGroups = compensationGroupSvc.getAllAsync();
    });

}]);
